module.exports = __webpack_public_path__ + "static/background_cooking_icons-2c070d690de42512ac28d4e50236830a.png";